import { GetCustomerCurrentYearPeriodicChecksInDto, GetCustomerCurrentYearPeriodicChecksOutDto } from '../../../types/periodic-check.dto'

export const GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS = 'GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS'
export const GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS = 'GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS'
export const GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR = 'GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR'
export const RESET_GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS = 'RESET_GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS'

export interface GetCustomerCurrentYearPeriodicChecks {
  type: typeof GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS
  payload: GetCustomerCurrentYearPeriodicChecksOutDto
}

export interface GetCustomerCurrentYearPeriodicChecksSuccess {
  type: typeof GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS
  payload: GetCustomerCurrentYearPeriodicChecksInDto
}

export interface GetCustomerCurrentYearPeriodicChecksError {
  type: typeof GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR
  payload: string | boolean
}

export interface ResetGetCustomerCurrentYearPeriodicChecks {
  type: typeof RESET_GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS
  payload: null
}

export interface State {
  data: GetCustomerCurrentYearPeriodicChecksInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetCustomerCurrentYearPeriodicChecks | GetCustomerCurrentYearPeriodicChecksSuccess | GetCustomerCurrentYearPeriodicChecksError | ResetGetCustomerCurrentYearPeriodicChecks 